/* eslint-disable no-shadow,no-restricted-syntax */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { actions, Errors, Form } from 'react-redux-form';
import { deleteCarousel, getCarousels, updateCarousels } from '../../../actions/home';
import ArrowButton from '../../common/button-arrow';
import Spinner from '../../common/form/spinner';
import IgniteDataTable from '../../common/datatable';
import ConfirmPopup from '../../common/confirm-popup';
import { history } from '../../../store';

import './style.css';
import {dateTimeFormatUK} from '../../../utils/commonFunctions';

class Carousel extends Component {
  state = {
    delete: {
      show: false
    }
  };

  handleDelete = (result) => {
    const { id } = this.state.delete;
    const { dispatch } = this.props;

    this.setState({ delete: { show: false } });

    if (result) {
      dispatch(deleteCarousel(id));
    }

    setTimeout(() => {
      dispatch(getCarousels());
    }, 100);
  };

  onSubmit = (payload) => {
    const { dispatch } = this.props;
    const newPayload = {
      position: {}
    };

    for (const key in payload) {
      if (/^position_/.test(key)) {
        const id = key.match(/\d+/)[0];
        newPayload.position[id] = payload[key];
      }
    }

    dispatch(actions.submitFields('deep.home_page_carousel', updateCarousels(newPayload)));
  };

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getCarousels());
  }

  getColumns() {
    const { carousels } = this.props;

    return [
      {
        prop: 'position',
        title: 'Position',
        format(data, row) {
          return (
            <Spinner
              max={carousels.length}
              min={1}
              model={`deep.home_page_carousel.position_${row.id}`}
              value={data}
            />
          );
        }
      },
      {
        prop: 'link',
        title: 'Thumbnail',
        format(data) {
          return (
            <img
              alt="carousel thumbnail"
              className="imgPreview"
              src={data.image}
            />
          );
        }
      },
      {
        prop: 'display-from-date',
        title: 'Display From',
        format(data) {
          return dateTimeFormatUK(data);
        }
      },
      {
        prop: 'display-to-date',
        title: 'Display To',
        format(data) {
          return dateTimeFormatUK(data);
        }
      },
    ];
  }

  getActions() {
    return [
      {
        label: 'Edit',
        callback: (row) => {
          history.push(`/admin/homepage/carousel/${row.id}/edit`);
        }
      },
      {
        label: 'Delete',
        disabled: row => row.attributes.fix,
        permissions: {
          action: 'handle',
          subjectClass: 'home_page',
        },
        callback: (row) => {
          this.setState({
            delete: {
              show: !this.state.delete.show,
              id: row.id
            }
          });
        }
      }
    ];
  }

  render() {
    const {
      carousels, carouselsFetched, type
    } = this.props;

    return (
      <div>
        <Row>
          <Col md={12}>
            <Link className="add-carousel" to={`/admin/homepage/carousel/${type}/new`}>
              <ArrowButton arrow={false} color="red" submit={false}>
                Add Slide
              </ArrowButton>
            </Link>
          </Col>
        </Row>
        {
          carouselsFetched && (
            <Row>
              <Col className="Carouselslist" md={12}>
                <Form model="deep.home_page_carousel" onSubmit={this.onSubmit}>
                  <Errors className="errors" model="deep.home_page_carousel"/>
                  <IgniteDataTable
                    actions={this.getActions()}
                    columns={this.getColumns()}
                    data={carousels}
                    remote
                    hideId={false}
                  />
                  <Row>
                    <ArrowButton className="save-carousels" color="red">
                      Save
                    </ArrowButton>
                  </Row>
                </Form>
              </Col>
            </Row>
          )}
        {
          this.state.delete.show && (
            <ConfirmPopup
              header="DELETE CAROUSEL SLIDE?"
              onClose={this.handleDelete}
            >
              <p>
                Are you sure you want to delete this carousel slide?
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  carousels: state.home.home_carousels,
  carouselsFetched: state.home.carousels_fetched,
  fetching: state.home.fetching,
  fetched: state.home.fetched
});

export default connect(mapStateToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/carousel.jsx